// input: [{id: 1, unitAmount: 1000, upTo: 5 }, {id: 2, unitAmount: 800, upTo: 10}]
// output: [{id: 1, minSeats: 2, maxSeats: 5, amountInDollars: 10}, {id: 2, minSeats: 6, maxSeats: -1, amountInDollars: 8}]
const getPricingTable = (tiers) => {
  return tiers.map((tier, index, tiers) => {
    const isFirst = index === 0
    const isLast = index === tiers.length - 1
    const { id, unitAmount, upTo } = tier
    const amountInDollars = unitAmount
    const lastTier = tiers[index - 1]
    if (isFirst) {
      return {
        id,
        minSeats: 2,
        maxSeats: upTo,
        amountInDollars,
      }
    }
    if (isLast) {
      return {
        id,
        minSeats: lastTier.upTo + 1,
        // -1 means that there is no upper limit
        maxSeats: -1,
        amountInDollars,
      }
    }
    return {
      id,
      minSeats: lastTier.upTo + 1,
      maxSeats: upTo,
      amountInDollars,
    }
  })
}

export { getPricingTable }
